var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCloseWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.918 17.5416L34.1675 5.29203C34.7489 4.7117 35.0759 3.92418 35.0766 3.10274C35.0774 2.28129 34.7518 1.4932 34.1714 0.911838C33.5911 0.330475 32.8036 0.00346128 31.9821 0.00273583C31.1607 0.00201038 30.3726 0.327633 29.7912 0.90797L17.5416 13.1576L5.29203 0.90797C4.71067 0.326607 3.92217 0 3.1 0C2.27783 0 1.48933 0.326607 0.90797 0.90797C0.326607 1.48933 0 2.27783 0 3.1C0 3.92217 0.326607 4.71067 0.90797 5.29203L13.1576 17.5416L0.90797 29.7912C0.326607 30.3726 0 31.1611 0 31.9832C0 32.8054 0.326607 33.5939 0.90797 34.1753C1.48933 34.7566 2.27783 35.0832 3.1 35.0832C3.92217 35.0832 4.71067 34.7566 5.29203 34.1753L17.5416 21.9257L29.7912 34.1753C30.3726 34.7566 31.1611 35.0832 31.9832 35.0832C32.8054 35.0832 33.5939 34.7566 34.1753 34.1753C34.7566 33.5939 35.0832 32.8054 35.0832 31.9832C35.0832 31.1611 34.7566 30.3726 34.1753 29.7912L21.918 17.5416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/mobile_close_white_icon.e56cdc4cf31e81d26f933d4119e9dfa5.svg";
export { ForwardRef as ReactComponent };